import React, { useState } from 'react';
import { MdOutlineDeleteForever } from 'react-icons/md';
import ConfirmationModal from '../../../common/ConfirmationModal';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deleteAccount } from '../../../../services/operations/profileApi';

const DeleteAccount = () => {
    const [confirmationModal, setConfirmationModal] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const confirmationModalData = {
        text1: "Are you absolutely sure?",
        text2: "You want to proceed and delete your account. Keep in mind that this action is irreversible.",
        btn1Text: "Delete",
        btn2Text: "Cancel",
        btn1Handler: () => dispatch(deleteAccount(navigate)),
        btn2Handler: () => setConfirmationModal(null),
    };

    return (
        <div>
            <div
                onClick={() => setConfirmationModal(confirmationModalData)}
                className='my-10 bg-pink-900 rounded-xl border border-pink-700 p-8 flex md:flex-row flex-col gap-y-3 gap-x-5 cursor-pointer'
            >
                <div className='bg-pink-700 rounded-full h-fit w-fit p-2'>
                    <MdOutlineDeleteForever className='text-4xl text-pink-200' />
                </div>
                <div className='flex flex-col gap-y-2'>
                    <header className='text-lg font-semibold'>Delete Account</header>
                    <p className='text-pink-50 lg:w-[60%] flex flex-col'>
                        <span className='leading-8'>Are you considering account deletion? </span>
                        <span> Please be aware that this account potentially includes paid courses. Proceeding with deletion is a permanent action that will result in the removal of all content associated with it.</span>
                    </p>
                    <span className='bg-pink-300 border-2 border-richblack-5 py-4 px-2 my-5 w-fit italic text-lg font-medium'>Click anywhere within this red area to proceed with account deletion.</span>
                </div>
            </div>
            {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
        </div>
    );
}

export default DeleteAccount;